import React from 'react';
import { IndicatorByStatus } from 'pureUi/BookingStatus';
import { IPurchaseOrderDetail } from 'services/BookingManagerApi/types/PurchaseOrdersSearchResponse';

interface Props {
  po: IPurchaseOrderDetail;
  bookingUuid: string;
  leadGuestName: string | null;
}

export const PurchaseOrderInfoPanel = ({ po, bookingUuid, leadGuestName }: Props) => (
  <div className="grid grid-cols-2 gap-6 px-[15px]">
    {/* BOOKING */}
    <div>
      <span className="font-pt-sans text-[11px] text-black uppercase tracking-wider block mb-[5px]">
        Booking
      </span>
      <div className="flex items-center gap-1 mb-1">
        <span className="font-pt-sans text-[13px] text-gray-100">#</span>
        <a
          href={`/bookings/${bookingUuid}`}
          className="font-pt-sans text-[13px] text-brown-100 underline"
        >
          {po.humanReadableId}
        </a>
      </div>
      <div className="flex items-center gap-2 mb-2">
        <IndicatorByStatus status={po.bookingStatus} />
        <span className="font-pt-sans text-[13px] text-black capitalize">{po.bookingStatus}</span>
      </div>
      <div className="flex items-center gap-1 font-pt-sans text-[13px] text-black">
        <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false" className="text-gray-100 shrink-0">
          <path fill="currentColor" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
        </svg>
        {leadGuestName ?? '—'}
      </div>
    </div>

    {/* SUPPLIER */}
    <div>
      <span className="font-pt-sans text-[11px] text-black uppercase tracking-wider block mb-[5px]">
        Supplier
      </span>
      <div className="font-pt-sans text-[13px] text-black mb-1">
        {po.supplierName ?? <span className="text-gray-60">—</span>}
      </div>
      <div className="font-pt-sans text-[13px] text-black mb-3 flex items-center gap-1">
        <span className="text-gray-100">#</span>
        {po.confirmationNumber ?? <span className="text-gray-60">—</span>}
      </div>
      <div className="flex gap-2">
        <span
          className={`px-2 py-0.5 text-[11px] font-pt-sans rounded border ${
            !po.paidByVcc ? 'border-gray-100 text-gray-100' : 'border-gray-40 text-gray-40'
          }`}
        >
          Static
        </span>
        <span
          className={`px-2 py-0.5 text-[11px] font-pt-sans rounded border ${
            po.paidByVcc ? 'border-blue-100 text-blue-100' : 'border-gray-40 text-gray-40'
          }`}
        >
          Live
        </span>
      </div>
    </div>
  </div>
);
